import { DataGrid } from '@mui/x-data-grid';
import { Card, CardHeader, Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useQuery } from '@apollo/client';
import GET_CATEGORIES from './categoryQuery';
import Loading from '../../shared/Loading';

export default function DisplayCategory() {
  const { loading, error, data } = useQuery(GET_CATEGORIES);
  if (loading) return <Loading />;
  if (error) return 'Error!';

  const columns = [
    { field: 'name', headerName: 'Category Name', width: 900 },
    {
      field: 'edit',
      headerName: 'Edit',
      width: 200,
      sortable: false,
      renderCell: (params) => (
        <strong>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => {
              // eslint-disable-next-line no-alert
              alert(params.id);
            }}
            startIcon={<EditIcon />}
          >
            EDIT
          </Button>
        </strong>
      )
    }
  ];
  const rows = data.categories;

  return (
    <Card>
      <CardHeader subheader="Currently Added Categories." title="Categories" />
      <div style={{ height: 400, width: '100%' }}>
        <DataGrid rows={rows} columns={columns} pageSize={5} />
      </div>
    </Card>
  );
}
